import React,{useState} from "react";
 import './../css/SettingDrawer.css';

import { CircleX,ChevronRight, HomeIcon,User,NotebookPen,CalendarClock, CircleCheckBig, NotepadText, Landmark, ChartNoAxesCombined, Megaphone, FileUser, KeyRound, CircleUserRound, LogOut } from "lucide-react";
import { useNavigate,useLocation } from "react-router-dom";

const SettingDrawer = ({show_settingdrawer,setSettingDrawer})=>{
            const navigate = useNavigate();
    const [staff,setStaff] = useState(JSON.parse(localStorage.getItem('staff')));

    return(<>
    <div className={`SettingDrawer ${show_settingdrawer ? 'SettingDrawer-open' : 'SettingDrawer-close'}`}>
            
            <div className="SettingDrawer-title">
                      <CircleX onClick={()=>setSettingDrawer(false)}/>  Settings
                        <div></div> 
                    </div>  
 <div className="Avtar-SettingDrawer"  >
               <img src={staff.pic != '' ?`https://new.proschoolerp.com/${staff.pic}`:'https://www.shutterstock.com/image-vector/vector-funny-cat-glasses-cute-600nw-2313634279.jpg'}/> 
            </div>
            <div className="SettingDrawer-name">
                {staff.name}
            </div>
<div className="SettingDrawer-menu_area">
    <br/>
       <div className="drawer-menues">
                
                <div className={`drawer-menu-item `}onClick={() => {
  navigate('account');
  setSettingDrawer(false);
}}>
                    <div className="menu-item-super">
                        <KeyRound/> Account  
                    </div> 
                    
                      <ChevronRight/> 
                    
                </div>
                <div className={`drawer-menu-item `} onClick={() => {
  navigate('profile');
  setSettingDrawer(false);
}}>
                    <div className="menu-item-super">
                        <CircleUserRound/> Profile  
                    </div> 
                    
                      <ChevronRight/> 
                    
                </div>
                <div className={`drawer-menu-item `}
                
                onClick={() => {
  localStorage.removeItem('staff');
             localStorage.removeItem('is_fcm_done');

  navigate('/');
  setSettingDrawer(false);
}}>
                    <div className="menu-item-super">
                        <LogOut/> Logout  
                    </div> 
                    
                      <ChevronRight/> 
                    
                </div>
                
                </div>
</div>
        </div>
      
        <div onClick={()=>setSettingDrawer(false)} className={`SettingDrawerOverlay ${show_settingdrawer ? 'SettingDrawer-open_overlay' : 'SettingDrawer-close_overlay'}`}></div>
    
    </>);

}
export default SettingDrawer;